import { forwardRef } from "react";
import { colorTokens } from "../../styles/tokens";
import {
  Normal,
  NormalStrong,
  Props,
  Small,
  SmallStrong,
  XSmall,
  XSmallStrong,
} from "./Body.Parts";

export const Body = forwardRef<HTMLElement, Props>(
  ({ children, tag, variant = "normal", color, ...rest }, ref) => {
    const colorValue =
      color && color in colorTokens
        ? colorTokens[color as keyof typeof colorTokens]
        : color;
    switch (variant) {
      case "normal":
        return (
          <Normal as={tag || "p"} ref={ref} $color={colorValue} {...rest}>
            {children}
          </Normal>
        );
      case "normal-strong":
        return (
          <NormalStrong as={tag || "p"} ref={ref} $color={colorValue} {...rest}>
            {children}
          </NormalStrong>
        );
      case "small":
        return (
          <Small as={tag || "small"} ref={ref} $color={colorValue} {...rest}>
            {children}
          </Small>
        );
      case "small-strong":
        return (
          <SmallStrong
            as={tag || "small"}
            ref={ref}
            $color={colorValue}
            {...rest}
          >
            {children}
          </SmallStrong>
        );
      case "xsmall":
        return (
          <XSmall as={tag || "small"} ref={ref} $color={colorValue} {...rest}>
            {children}
          </XSmall>
        );
      case "xsmall-strong":
        return (
          <XSmallStrong
            as={tag || "small"}
            ref={ref}
            $color={colorValue}
            {...rest}
          >
            {children}
          </XSmallStrong>
        );
      default:
        return (
          <Normal as={tag || "p"} ref={ref} $color={colorValue} {...rest}>
            {children}
          </Normal>
        );
    }
  },
);
